import { Lock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * BLU-377: independent payment-state badge, rendered next to the
 * fulfillment status badge. Two states:
 *
 * - 'paid': filled emerald + Lock icon — distinct from the soft `received`
 *   status badge so the locked terminal state reads unmistakably.
 * - 'unpaid': muted outline — present on the page but understated.
 *   Helps an Admin spot a PO that is "received but not paid" at a glance.
 */
interface PaymentStatusBadgeProps {
  paymentStatus: 'unpaid' | 'paid' | null | undefined;
  className?: string;
}

export const PaymentStatusBadge = ({ paymentStatus, className }: PaymentStatusBadgeProps) => {
  const isPaid = paymentStatus === 'paid';

  if (isPaid) {
    return (
      <Badge variant="paid" className={cn('flex items-center gap-1.5 px-3 py-1', className)}>
        <Lock className="h-3.5 w-3.5" aria-hidden="true" />
        PAID
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className={cn('flex items-center gap-1 px-2.5 py-1 text-muted-foreground', className)}>
      UNPAID
    </Badge>
  );
};
